import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import SidebarMenu from 'components/menu/SidebarMenu.component';
import { withTranslation } from 'providers/GILT.provider';

import TopNav from 'common/TopNav.component';
import { getAllExactClientList, mergeClient } from 'mergeClients/actions';
import TableDuplicateClientResult from 'mergeClients/components/ExactDuplicates/TableDuplicateClientResult';
import { trackEvent } from 'tracking/actions';

import CN from './ExactDuplicatesLayout.module.scss';

class ExactDuplicatesLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  UNSAFE_componentWillMount() {
    this.props.getAllExactClientList(this.props.salonId);
  }

  render() {
    const { salonId, isMerging, loadingClientsData, mergeClient, clientList, t } = this.props;

    return (
      <div data-bem="ExactDuplicatesLayout" className={CN.component}>
        <TopNav>
          <SidebarMenu />
        </TopNav>

        {loadingClientsData && (
          <div className="spinner-container in-marketing-clients">
            <div className="load-spinner" />
            <span className="spinner-text">{t('exactDuplicateClients.loadingDuplicates')}</span>
          </div>
        )}

        {!loadingClientsData && (
          <div data-bem="ExactDuplicatesLayout__container">
            <TableDuplicateClientResult
              clientList={clientList}
              salonId={salonId}
              mergeClient={mergeClient}
              disableMergeAllButton={isMerging}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  salonId: state.currentSalon.id,
  ...state.mergeClients,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAllExactClientList,
      mergeClient,
      trackEvent,
    },
    dispatch,
  );

const ExactDuplicatesLayoutHoc = connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ExactDuplicatesLayout));

export default ExactDuplicatesLayoutHoc;
